export default __webpack_public_path__ + "static/media/bg-shape-2.45ab4692.png";